import React from 'react';
import PropTypes from 'prop-types';

import {FormInline, CheckboxInput} from '../../../fragments/forms';
import Button from '../../../fragments/button';
import SelectControl from '../../../fragments/select-control';


import API from '../hivdb/api';

import style from './style.css';
import moment from 'moment';


export default class UpdateBtns extends React.Component {

  static propTypes = {
    rawDataCollection: PropTypes.object.isRequired,
    onUpdateColumn: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
  };

  static defaultProps = {
    disabled: false,
  };

  constructor() {
    super(...arguments);
    this.state = {
      source: {
        options: [],
        choice: '',
        prompt: "Change source ...",
        btnPrompt: 'Batch Change Source',
      },
      region: {
        options: [],
        choice: '',
        prompt: "Change region ...",
        btnPrompt: 'Batch change region',
      },
      isolateDate: {
        btnPrompt: 'Batch Change IsolateDate',
        startDate: '',
        stopDate: '',
        placeholder: '2020-01-01',
        notHaveSampleYear: false,
      },
      ptAlias: {
        prompt: "Using IsolateName as ptAlias",
        btnPrompt: 'Using IsolateName as ptAlias',
        checked: false,
      },
      isChild: {
        prompt: "All sequences are from children",
        btnPrompt: "",
        checked: false,
      },
      isNGS: {
        prompt: "cloned using NGS",
        btnPrompt: "",
        checked: false,
      }
    };
  }

  async componentDidMount() {
    this.loadOptions();
  }

  async loadOptions() {
    const {source, region} = this.state;

    const data = await API({ldInclude: true});
    const {viewer: {
      BodySourceList,
      CountryList}
    } = data;

    let sourceList = BodySourceList.edges.map((node) => node.node.source);
    sourceList = sourceList.filter((source) => {
      return (source !== 'PBMC') && (source !== 'Plasma');
    });
    sourceList.unshift('Plasma');
    sourceList.unshift('PBMC');

    source.options = sourceList.map((source) => {

      return {
        value: source,
        label: source,
      };
    });

    region.options = CountryList.edges.map((node) => {
      const region = node.node.region;
      return {
        value: region,
        label: region,
      };
    });
    this.setState({
      source,
      region
    });
  }

  handleChooseSource = (e) => {
    e.preventDefault();

    const {source} = this.state;
    source.choice = e.target.value;
    this.setState({source});
  };

  handleChooseRegion = (e) => {
    e.preventDefault();

    const {region} = this.state;
    region.choice = e.target.value;
    this.setState({region});
  };

  handleInputStartIsolateDate(e) {
    e.preventDefault();

    const {isolateDate} = this.state;
    isolateDate.startDate = e.target.value;
    isolateDate.stopDate = e.target.value;
    this.setState({isolateDate});
  }

  handleInputStopIsolateDate(e) {
    e.preventDefault();

    const {isolateDate} = this.state;
    isolateDate.stopDate = e.target.value;
    this.setState({isolateDate});
  }

  handleCheckSampleYear() {
    const {isolateDate} = this.state;
    isolateDate.notHaveSampleYear = !isolateDate.notHaveSampleYear;
    this.setState({isolateDate});
  }

  handleChooseUpdatePtAlias() {
    const {ptAlias} = this.state;
    ptAlias.checked = !ptAlias.checked;
    this.setState({ptAlias});
  }

  handleChooseUpdateIsChild() {
    const {isChild} = this.state;
    isChild.checked = !isChild.checked;
    this.setState({isChild});
  }

  handleChooseUpdateIsNGS() {
    const {isNGS} = this.state;
    isNGS.checked = !isNGS.checked;
    this.setState({isNGS});
  }

  async handleUpdateColumn() {
    const {
      source,
      region,
      isolateDate,
      ptAlias,
      isChild,
      isNGS,
    } = this.state;

    const {rawDataCollection} = this.props;

    const {onUpdateColumn} = this.props;

    if (source.choice !== '') {
      await onUpdateColumn('Source', source.choice);
    }

    if (region.choice !== '') {
      await onUpdateColumn('Region', region.choice);
    }

    if (isolateDate.notHaveSampleYear && isolateDate.startDate === '') {
      const reference = rawDataCollection.references[0];
      const isolateDate = moment(
        `${reference.refYear}-01-01`).subtract(
        2, 'years').format(
        'YYYY-MM-DD');
      await onUpdateColumn('Isolate Date', isolateDate);
      await onUpdateColumn('Isolate Date Match', '<=');
    }

    if (isolateDate.startDate !== '') {
      onUpdateColumn('Isolate Date', isolateDate.stopDate);
      if (isolateDate.startDate === isolateDate.stopDate) {
        await onUpdateColumn('Isolate Date Match', 'eq');
      } else {
        await onUpdateColumn('Isolate Date Match', 'lteq');
      }
    }

    if (ptAlias.checked) {
      await onUpdateColumn('PtAlias', 'Isolate Name');
    }

    if (isChild.checked) {
      await onUpdateColumn('isChild', 'Yes');
    } else {
      await onUpdateColumn('isChild', 'No');
    }

    if (isNGS.checked) {
      await onUpdateColumn('seqMethod', 'NGS');
    } else {
      await onUpdateColumn('seqMethod', 'Dideoxy');
    }

    const {onSave} = this.props;
    await onSave();
  }

  get hasCloneSequence() {
    const {rawDataCollection} = this.props;
    let hasCloneSequence = false;
    for (const rawSeq of rawDataCollection.rawSequences) {
      if (rawSeq.cloneName && rawSeq.cloneName !== '') {
        hasCloneSequence = true;
        break;
      }
    }
    return hasCloneSequence;
  }

  render() {
    const {
      source,
      region,
      isolateDate,
      ptAlias,
      isChild,
      isNGS,
    } = this.state;

    return (
      <div className={style['update-form']}>
        <h3>
          Batch update
        </h3>
        <FormInline dom="div">
          <span className={style.controlGroup}>
            <CheckboxInput
             name="ptAlias"
             checked={ptAlias.checked}
             onChange={this.handleChooseUpdatePtAlias.bind(this)} >
              {ptAlias.prompt}
            </CheckboxInput>
          </span>
        </FormInline>
        <FormInline dom="div">
          <span className={style.controlGroup}>
            <CheckboxInput
             name="isChild"
             checked={isChild.checked}
             onChange={this.handleChooseUpdateIsChild.bind(this)} >
              {isChild.prompt}
            </CheckboxInput>
          </span>
        </FormInline>
        {this.hasCloneSequence ?
          <FormInline dom="div">
            <span className={style.controlGroup}>
              <CheckboxInput
               name="isNGS"
               checked={isNGS.checked}
               onChange={this.handleChooseUpdateIsNGS.bind(this)} >
                {isNGS.prompt}
              </CheckboxInput>
            </span>
          </FormInline> : null
        }
        <FormInline dom="div">
          <span className={style.controlGroup}>
            {'Change Sample Year: '}
          </span>
          <span className={style.controlGroup}>
            <input
             value={isolateDate.startDate}
             placeholder={isolateDate.placeholder}
             onChange={
              this.handleInputStartIsolateDate.bind(this)}
              />
          </span>
          {'-'}
          <span className={style.controlGroup}>
            <input
             value={isolateDate.stopDate}
             placeholder={isolateDate.placeholder}
             onChange={
              this.handleInputStopIsolateDate.bind(this)}
              />
          </span>
          {'or'}
          <span className={style.controlGroup}>
            <CheckboxInput
             name="sampleyear"
             checked={isolateDate.notHaveSampleYear}
             onChange={this.handleCheckSampleYear.bind(this)}>
              Not available
            </CheckboxInput>
          </span>
        </FormInline>
        <FormInline dom="div">
          <span className={style.selectGroup}>
            <SelectControl
             options={source.options}
             value={source.choice}
             prompt={source.prompt}
             onChange={this.handleChooseSource.bind(this)} />
          </span>
          <span className={style.selectGroup}>
            <SelectControl
             options={region.options}
             value={region.choice}
             prompt={region.prompt}
             onChange={
              this.handleChooseRegion.bind(this)} />
          </span>
        </FormInline>
        <FormInline dom="div">
          <Button
           btnStyle="default"
           onClick={
            this.handleUpdateColumn.bind(this)}
          >
            Update all
          </Button>
        </FormInline>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/wizard/isolate/gtable_mut/update-btns.js